<template>
    <nav class="layout-breadcrumb">
        <ol>
            <template v-for="(crumb, i) in crumbs" :key="i + '_' + crumb.label">
                <li class="font-medium text-surface-950 dark:text-surface-0 text-xl">
                    <router-link v-if="crumb.to && i !== crumbs.length - 1" :to="crumbTarget(crumb)!" class="hover:text-primary">{{ crumb.label }}</router-link>
                    <template v-else>{{ crumb.label }}</template>
                </li>
                <li v-if="i !== crumbs.length - 1" class="layout-breadcrumb-chevron">/</li>
            </template>
        </ol>
    </nav>
</template>

<script setup lang="ts">
import { clearRecordCrumbs, crumbTarget, recordCrumbs, recordKey, type Crumb } from '@/composables/useBreadcrumb';
import { computed, watch } from 'vue';
import { useRoute } from 'vue-router';

// The route's crumbs, then the record's crumbs its View supplied. Every route carries
// meta.breadcrumb, so the Poseidon fallback that derived crumbs from the path is gone.
const route = useRoute();

const crumbs = computed<Crumb[]>(() => [...((route.meta.breadcrumb as Crumb[] | undefined) ?? []), ...recordCrumbs.value]);

// a query change (paging, a panel opened by ?location=) keeps the record's crumbs; another record does not.
// A string key, not an array: a fresh array on every route change would fire the watcher on a query change too
watch(
    () => recordKey(route),
    () => clearRecordCrumbs()
);
</script>
